import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { TagItem } from '../../../common/FormExpandableSection/FormExpandableSection';

export function getAudienceTargetingTags(lists?: TargetingBaseType['audience']['lists']): TagItem[] {
  const count = lists?.length ?? 0;
  if (count === 0) {
    return [];
  }

  return [{ label: `${count} audience group${count !== 1 ? 's' : ''}` }];
}
